/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

export default {
      TeleClaimStatusFields: '$MHF_ModelNameVal_$MHF|TeleClaimStatusFields',

};
